import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// mui components
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import LoadingButton from '@mui/lab/LoadingButton';
// Services
import { useGetAdminAuthTokenMutation } from 'src/app/services/webApi.service';
import { updateToken } from 'src/app/store/stateSlice/adminSlice';
// shared components
import TitleWithUnderline from 'src/app/shared/TitleSection';
import { useAppDispatch } from 'src/app/store/stateTypeHook';
import { IToast, Toast } from 'src/app/shared/Toast';

function AdminLoginComponent() {
    const [userEmail, setEmail] = useState('');
    const [userPassword, setPassword] = useState('');
    const [showToast, setShowToast] = React.useState<IToast>({});

    const navigate = useNavigate();
    // RTQ queries
    const [getToken, authResponse] = useGetAdminAuthTokenMutation();
    const dispatch = useAppDispatch();

    const getAuthToken = () => {
        getToken({ email: userEmail, password: userPassword });
    };

    useEffect(() => {
        if (authResponse.isSuccess) {
            dispatch(
                updateToken({
                    access_token: 'bearer ' + authResponse.data.access_token,
                    expires_in: authResponse.data.expires_in,
                })
            );
        }

        navigate('/super-admin/booking-actions');
    }, [authResponse.isSuccess]);

    useEffect(() => {
        if (authResponse.isError) {
            setShowToast({
                show: true,
                sticky: false,
                severity: 'error',
                message: 'Your login details are incorrect. Please try again or reset your password.',
            });
        }
    }, [authResponse.isError]);

    return (
        <Box sx={{ pb: { xs: '42px', md: '30px' } }}>
            <Box sx={{ p: { xs: '0 16px 30px', md: '0 30px 30px' } }}>
                <TitleWithUnderline>
                    <Box flexGrow={1}>
                        <Typography variant='h5' gutterBottom component='div' marginBottom={'0'} fontSize={'24px'}>
                            Login
                        </Typography>
                    </Box>
                </TitleWithUnderline>

                <Box
                    sx={{
                        width: '330px',
                        mx: 'auto',
                        mt: '20vh',
                        pb: 3,
                    }}
                >
                    <Paper sx={{ width: '100%', pb: 1 }}>
                        <Paper
                            elevation={0}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                height: '60px',
                                mb: 3,
                                px: '12px',
                                backgroundColor: (theme) => theme.palette.primary.main,
                            }}
                        >
                            <Typography color='white.main' fontSize={'1.5rem'}>
                                Login
                            </Typography>
                        </Paper>
                        <Box
                            component='form'
                            sx={{
                                px: '12px',
                                '& .MuiTextField-root': {
                                    width: '100%',
                                    my: 1,
                                },
                            }}
                        >
                            <div>
                                <TextField
                                    required
                                    id='email'
                                    label='Email'
                                    autoComplete='off'
                                    name='email'
                                    type='email'
                                    value={userEmail}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                <TextField
                                    required
                                    id='password'
                                    label='Password'
                                    type='password'
                                    name='password'
                                    value={userPassword}
                                    autoComplete='current-password'
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>
                            <LoadingButton
                                variant='contained'
                                color='primary'
                                sx={{ display: 'block', mt: 1, ml: 'auto' }}
                                loading={authResponse.isLoading}
                                onClick={getAuthToken}
                            >
                                Login
                            </LoadingButton>
                        </Box>
                    </Paper>
                </Box>
            </Box>
            {showToast.show && <Toast {...showToast} onClose={(show: boolean) => setShowToast({})} />}
        </Box>
    );
}

export default AdminLoginComponent;
